import {Alert, List, ListItem, Snackbar, Theme, useMediaQuery} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {about_me, change_nickname} from "../apis/Auth";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Layout from "../utilities/Layout";
import Typography from "@mui/material/Typography";
import GA4EventSend from "../utilities/GA4EventSend";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {Helmet} from "react-helmet";

export default function ChangeNickname() {
    if (localStorage.getItem("user") === null) {
        let pathname = encodeURIComponent("/change-nickname");
        window.location.href = "/signin/redirect?path=" + pathname;
    }

    const [open, setOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [isClicked, setIsClicked] = useState(false);
    const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
    const [severity, setSeverity] = useState<"success" | "error" | "info" | "warning" | undefined>("error");
    const [isMdOrUp, setIsMdOrUp] = useState(useMediaQuery((theme: Theme) => theme.breakpoints.up('md')));
    useEffect(() => {
        const handleResize = () => {
            setIsMdOrUp(window.innerWidth >= 960);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMdOrUp]);

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function handleChange(event: React.ChangeEvent<HTMLFormElement>) {
        const data = new FormData(event.currentTarget);
        const nickname = data.get('nickname') as string ?? "";
        setButtonEnabled(
            nickname.length > 0 && nickname.length < 21
        );
    }

    async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        setIsClicked(true);
        const data = new FormData(event.currentTarget);
        const nickname = data.get('nickname') as string ?? "";
        if (nickname.length > 0 && nickname.length < 21) {
            let response = await change_nickname(localStorage.getItem("access_token") ?? "", localStorage.getItem("refresh_token") ?? "", nickname);
            if (response.succeeded) {
                let ab_response = await about_me(localStorage.getItem("refresh_token") ?? "", localStorage.getItem("access_token") ?? "");
                if (ab_response.succeeded) {
                    localStorage.setItem('user', JSON.stringify(ab_response.data));
                } else {
                    console.error(response.message);
                }
                setSeverity("success");
                setMessage(response.message);
                setOpen(true);
            } else {
                setSeverity("error");
                setMessage(response.message);
                setOpen(true);
            }
            GA4EventSend("change_nickname", "user", "change_nickname", response.statusCode, false);
        }
        setIsClicked(false);
    }

    return (
        <Layout>
            <CssBaseline/>
            <Helmet>
                <title>DRBB | Change Nickname</title>
            </Helmet>
            <Snackbar anchorOrigin={{vertical: "top", horizontal: "center"}} open={open} onClose={handleClose}
                      autoHideDuration={6000}>
                <Alert elevation={6} severity={severity} sx={{width: '100%'}} variant="filled">
                    {message}
                </Alert>
            </Snackbar>
            <Box sx={{
                height: isMdOrUp ? '65vh' : 'fit-content',
                width: '100%',
                display: 'flex',
                m: 2,
                borderRadius: '10px'
            }}>
                <Paper elevation={3} sx={{
                    padding: 2,
                    margin: 'auto',
                    width: 'fit-content',
                    height: 'fit-content'
                }}>
                    <Grid container direction={"column"} component={"form"} onSubmit={handleSubmit}
                          onChange={handleChange}
                          sx={{
                              maxWidth: '300px',
                              margin: 'auto',
                              padding: 1,
                          }}
                    >
                        <Typography variant={"h4"} sx={{textAlign: 'center', mb: 2}} fontWeight={"bold"}>
                            Change Nickname
                        </Typography>
                        <TextField
                            required
                            fullWidth
                            name="nickname"
                            label="Nickname"
                            id="nickname"
                            onChange={() => {
                            }}
                        />
                        <List sx={{listStyleType: 'disc'}}>
                            <ListItem sx={{display: 'list-item'}}>
                                Nickname must be 20 characters or shorter.
                            </ListItem>
                        </List>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                            disabled={isClicked || !buttonEnabled}
                        >
                            Change Nickname
                        </Button>
                    </Grid>
                </Paper>
            </Box>
        </Layout>
    )
}